module.exports = __webpack_public_path__ + "a462018c8c62eb1afb1255dfac13bab1.svg";


//////////////////
// WEBPACK FOOTER
// ./res/images/logo/hu/apple_store.svg
// module id = 844
// module chunks = 0